import React from 'react';
import Navbar from './navbar';
import Footer from './footer';
import  '../index.css'

const HomePage = () => {
  return (
    <>
     {/* Navbar */}
     <Navbar />
      <div className="main-content">
        {/* Main Content */}
        <div className="col-md-9 mx-auto">
          <h1>Welcome to the Home Page</h1>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default HomePage;
